import * as mutations from './mutations';
import * as actions from './actions';
import * as getters from './getters';
import { state } from './state';

export default {
  strict: true,
  state,
  mutations,
  actions,
  getters,
};
